import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  STS_AUTHORITY: 'https://app-ppu-identity-server-dev-canadacentral.azurewebsites.net/',
  CLIENT_ID: 'PPU.Web.Portal.Pulse',
  CLIENT_ROOT: 'https://dev.partner.penguinpickup.com/',
  CLIENT_SCOPE: 'PPU.Identity.Api PPU.Administration.Api openid profile offline_access role',
  API_ROOT: 'https://app-ppu-admin-api-dev-canadacentral.azurewebsites.net/',
  STRIPE_KEY: 'pk_test_51KnjoVBqMdHwrHLezHVXGTmJIwZtdajWrKUAp7EWDLJDdrdWR5FczUpLs9Uqwvj1vt45hS1HpKm4f9qr3Vt3BUb800ykL9HSyG',
  BLOB_STORAGE_URL: 'https://ppu2devstorageaccount.blob.core.windows.net'
};

export const environment = Object.assign(commonEnv, env);
